













import { to } from '@tencent/wphk-base-utils';
import { CustomException } from '@tencent/ppd-base-libs';
import { HomeBanner  } from '@/types/home';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from './content-loader.vue';
import { defineComponent, ref, onMounted } from '@vue/composition-api';
import { getTopBannerList } from './api';
import Banner from '@tencent/wphk-components-banner';
import { useBannerList } from '../hooks/use-banner-list';

export default defineComponent({
  name: 'TopBanner',
  components: {
    BaseComponent,
    ContentLoader,
    Banner,
  },
  setup(props, { emit }) {
    // TopBanner是否准备完毕
    const isTopBannerReady = ref(false);
    // 是否展示顶部banner模块
    const showTopBanner = ref(true);
    // 顶部banner列表数据
    const topBannerList = ref<HomeBanner[]>([]);
    // 传递给banner组件的数据
    const { bannerList } = useBannerList(topBannerList, 'topBanner');
    onMounted(async () => {
      const [err, topBannerListRes] = await to(getTopBannerList());
      if (err) {
        emit('emptyData');
        showTopBanner.value = false;
        throw new CustomException(err, 'getTopBannerListFail', '获取topBanner列表失败');
      }
      if (topBannerListRes.length > 0) {
        isTopBannerReady.value = true;
        topBannerList.value = topBannerListRes;
      } else {
        showTopBanner.value = false;
        emit('emptyData');
      }
    });
    return {
      showTopBanner,
      isTopBannerReady,
      bannerList,
    };
  },
});
